import React from "react";
import FailedCollection from "../../../Collection/Failed/Index";

// Failed collections for consignment bookings, same page as loan
const Index = () => <FailedCollection bookingType="consignment" />;

export default Index;
